(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6766],{

/***/ 76766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_shopbycategory_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5640);
/* harmony import */ var _styles_shopbycategory_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_shopbycategory_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88494);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71911);
/* harmony import */ var _data_home__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44330);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);








swiper__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_4__/* .Pagination */ .tl
]);
var ShopByCategory = function() {
    var slides = [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: (_styles_shopbycategory_module_scss__WEBPACK_IMPORTED_MODULE_7___default().shopbycategory),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container-fluid",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_shopbycategory_module_scss__WEBPACK_IMPORTED_MODULE_7___default().shopbycategoryheader),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: (_styles_shopbycategory_module_scss__WEBPACK_IMPORTED_MODULE_7___default().shopbycategoryheader_head),
                            children: _data_home__WEBPACK_IMPORTED_MODULE_5__/* .homeLinks.shopByCategory.title */ .n.shopByCategory.title
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, {
                        className: "swiper-navigation-black swiper-custom-arrows pb-4",
                        spaceBetween: 0,
                        slidesPerView: 6,
                        navigation: true,
                        modules: [
                            swiper__WEBPACK_IMPORTED_MODULE_4__/* .Navigation */ .W_
                        ],
                        centeredSlides: false,
                        breakpoints: {
                            1199: {
                                slidesPerView: 6
                            }
                        },
                        children: _data_home__WEBPACK_IMPORTED_MODULE_5__/* .homeLinks.shopByCategory.sliders.map */ .n.shopByCategory.sliders.map(function(v, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                    href: v.link,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "shopbycategory_image",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                src: v.image,
                                                className: "img-fluid",
                                                alt: v.alt,
                                                height: 163,
                                                width: 163
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: v.name
                                            })
                                        ]
                                    })
                                })
                            }, i);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ShopByCategory);


/***/ }),

/***/ 5640:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shopbycategory":"shopbycategory_shopbycategory__3LKTi","shopbycategoryheader":"shopbycategory_shopbycategoryheader__k1fcS","shopbycategoryheader_head":"shopbycategory_shopbycategoryheader_head__gbcRZ","shopbycategory_image":"shopbycategory_shopbycategory_image__A99Db","swiper_button_prev_1":"shopbycategory_swiper_button_prev_1__fkWRh","swiper_button_next_1":"shopbycategory_swiper_button_next_1__H_hbr","icon-color":"shopbycategory_icon-color__Bhdcp"};

/***/ })

}]);